import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useUserFirms, SCREENS } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';
import BusinessIcon from '@mui/icons-material/Business';

const UserFirmDetailPage = () => {
  const { t } = useTranslation();
  const { userId } = useParams();

  const customFormFields = useCallback((fields, additionalData) => {
    const availableFirms = additionalData?.availableFirms ?? [];
    const assignedFirmIds = new Set(
      (additionalData?.userFirms ?? []).map(uf => uf.firm_id)
    );

    return fields.map(field => {
      if (field.name === 'firmIds') {
        const unassigned = availableFirms.filter(f => !assignedFirmIds.has(f.id));
        return {
          ...field,
          options: unassigned.map(f => ({
            value: f.id,
            label: f.firm_short_name
              ? `${f.firm_name} (${f.firm_short_name})`
              : f.firm_name,
          })),
        };
      }
      return field;
    });
  }, []);

  const customFilterConfigs = useCallback(() => [], []);

  const customRowActions = useCallback(() => [
    {
      type: 'delete',
      label: t('userFirms.removeFirm'),
      color: 'error',
      icon: <BusinessIcon />,
    },
  ], [t]);

  const customTitle = useCallback(() => t('userFirms.title'), [t]);

  const hookConfig = useCallback(() => ({ userId: parseInt(userId) }), [userId]);

  return (
    <DynamicCrudPage
      entityType="userFirms"
      screen={SCREENS.USERS}
      hook={useUserFirms}
      hookConfig={hookConfig}
      customFormFields={customFormFields}
      customFilterConfigs={customFilterConfigs}
      customTitle={customTitle}
      addButtonTextKey="userFirms.addFirmToUser"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="userFirm"
      customRowActions={customRowActions}
      showAddButton={true}
      exportButton={false}
      deleteConfirmText={t('userFirms.removeFirmConfirm')}
    />
  );
};

export default UserFirmDetailPage;
